import {
    Accordion,
    ActionIcon,
    Anchor,
    Box,
    Button,
    Center,
    Checkbox,
    DEFAULT_THEME,
    Grid,
    Group,
    Loader,
    Modal,
    Paper,
    Popover,
    Select,
    Stepper,
    Text,
    TextInput
} from "@mantine/core";
import {Checks, FileAlert, FileUpload} from "tabler-icons-react";
import UseFileInput from "../../features/file-input/use-file-input";
import React, {useEffect, useState} from "react";
import {showNotification} from "@mantine/notifications";
import {useForm} from "@mantine/form";
import * as Yup from 'yup';
import {
    useLazyGetFileQuery,
    useRequestWithFormDataMutation,
    useSpeakerMutation
} from "../../store/slice/customApiSlice";
import {IconChecks, IconCircleX, IconFileMinus, IconFilePlus, IconSearch} from "@tabler/icons";
import {useDisclosure, useMediaQuery} from "@mantine/hooks";
import {DatePicker} from "@mantine/dates";
import 'dayjs/locale/ru';
import dateFormatTo from "../../services/date-format-to";

const customLoader = (
    <svg
        width="54"
        height="54"
        viewBox="0 0 38 38"
        xmlns="http://www.w3.org/2000/svg"
        stroke={DEFAULT_THEME.colors.blue[6]}
    >
        <g fill="none" fillRule="evenodd">
            <g transform="translate(1 1)" strokeWidth="2">
                <circle strokeOpacity=".5" cx="18" cy="18" r="18"/>
                <path d="M36 18c0-9.94-8.06-18-18-18">
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 18 18"
                        to="360 18 18"
                        dur="1s"
                        repeatCount="indefinite"
                    />
                </path>
            </g>
        </g>
    </svg>
);


type applicantLaborActivityType = {
    end: string // Уход
    untilNow: boolean // По настоящее время
    location: string // Место работы
    organization: string // Организация
    position: string // Должность
    start: string // Приход
}

// type ReferenceType = {
//   code: string // Код
//   id: number // ID
//   title: string // Название
//   type: ReferenceType & { editable: boolean } // Тип
// }

const LanguageLevel = ["A1", "A2", "B1", "B2", "C1"]
type LanguageLevelType = typeof LanguageLevel[number]
// const status = ['ACCEPTED', 'REJECTED', 'PENDING', 'DELETED']
// type StatusType = typeof status[number]

// type WorkPeriodType = {
//   dateBegin: string;
//   dateEnd: string;
//   inn: string;
//   numSF: string;
//   payer: string;
//   pin_lss: string;
// }

// type ApplicantStatement = {
//   actualResidence: string | null; // Фактическое место жительства
//   address: string | null; // Адрес
//   applicantLaborActivities: applicantLaborActivityType[] | null;
//   citizenship: ReferenceType | null; // Гражданство
//   createdAt: string | null;// Дата создания
//   criminalRecord: string | null; // Судимость
//   dateOfBirth: string | null;// Дата рождения
//   dateOfNotarialAct: string | null;// Дата нотариального акта
//   decidedAt: string | null; // Решение
//   decidedBy: string | null;// Решение
//   diploma: FileList | null;
//   education: ReferenceType | null; // Образование
//   email: string | null;
//   gender: ReferenceType | null; // Пол
//   id: number | null;
//   inn: string | null;
//   laborContract: FileList | null;
//   languageLevel: LanguageLevelType | null;
//   name: string | null;
//   note: string | null;
//   patronymic: string | null;
//   phone: string | null;
//   photo: string | null;
//   placeOfBirth: string | null;
//   reference: FileList | null;
//   registerNumber: string | null;
//   status: StatusType | null;
//   workPeriod: WorkPeriodType | null;
// }

type SignUpPayload = {
    actualResidence: string | null;
    // citizenshipId: number | null;
    dateOfNotarialAct: string | null;
    // educationId: number | null;
    email: string | null;
    inn: string | null;
    laborActivities: applicantLaborActivityType[];
    // languageLevel: LanguageLevelType | null;
    languageLevelCertificate: File[] | null;
    passportNumber: string | null;
    passportSeries: string | null;
    phone: string | null;
    pinCode: string | null;
    placeOfBirth: string | null;
    registerNumber: string | null;
    //file
    // application: FileList | null;
    diploma: File[] | null;
    laborContract: File[] | null;
    legalSpecialityDocument: File[] | null;
    reference: File[] | null;
    paymentReceipt: File[] | null;
}

export const ApplicationForm = ({exit}: { exit?: () => void; }) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [checked, setChecked] = useState<boolean>(false);
    const [laborContract, setLaborContract] = useState<boolean>(false);
    const [reference, setReference] = useState<boolean>(false);
    const [active, setActive] = useState(0);
    const [dataAgreement, setDataAgreement] = useState<string | null>(null);
    const [openAgreement, setOpenAgreement] = useState<boolean>(false)

    const [opened, {close, open}] = useDisclosure(false);

    const mobileSize = useMediaQuery('(max-width: 767px)')

    const schema = Yup.object({
        email: Yup.string().email('неверный формат почты').required('Введите почту'),
    })

    const [request, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useRequestWithFormDataMutation();

    const [search] = useSpeakerMutation();
    const [getFile] = useLazyGetFileQuery();

    const form = useForm<SignUpPayload>({
        initialValues: {
            actualResidence: null,
            dateOfNotarialAct: null,
            email: null,
            inn: null,
            laborActivities: [{
                start: '',
                end: '',
                untilNow: false,
                position: '',
                organization: '',
                location: '',
            }],
            // languageLevel: null,
            languageLevelCertificate: null,
            phone: null,
            passportSeries: null,
            passportNumber: null,
            pinCode: null,
            placeOfBirth: null,
            registerNumber: null,
            // application: null,
            diploma: null,
            laborContract: null,
            legalSpecialityDocument: null,
            reference: null,
            paymentReceipt: null,
        },
        // validate: {
        //   ...yupResolver(schema),
        //   inn: (value: string) => value?.length < 14 ? 'Введите ПИН' : undefined,
        //   phone: (value: string) => !value ? 'Введите номер телефона' : undefined,
        //   pinCode: (value: string) => !value ? 'Введите ПИН-код' : undefined,
        //   // languageLevel: (value: string) => !value ? 'Выберите уровень владения языком' : undefined,
        //   placeOfBirth: (value: string) => !value ? 'Введите адрес места рождения' : undefined,
        //   actualResidence: (value: string) => !value ? 'Введите адрес места фактического проживания' : undefined,
        //   passportNumber: (value: string) => !value ? 'Введите номер паспорта' : undefined,
        //   passportSeries: (value: string) => !value ? 'Введите серию паспорта' : undefined,
        //   laborActivities: {
        //     start: (value: string) => !value ? 'Введите дату начала' : undefined,
        //     // end: (value: string) => !value ? 'Введите дату окончания' : undefined,
        //     location: (value: string) => !value ? 'Введите место работы' : undefined,
        //     organization: (value: string) => !value ? 'Введите наименование организации' : undefined,
        //     position: (value: string) => !value ? 'Введите должность' : undefined,
        //   }
        // },
    });

    const onSubmit = form.onSubmit(async ({
                                              // application,
                                              diploma,
                                              laborContract,
                                              legalSpecialityDocument,
                                              reference,
                                              languageLevelCertificate,
                                              paymentReceipt,
                                              ...body
                                          }) => {

        const files = {
            diploma: diploma,
            legalSpecialityDocument: legalSpecialityDocument,
            // application: application,
            languageLevelCertificate: languageLevelCertificate,
            laborContract: laborContract ? laborContract : null,
            reference: reference ? reference : null,
            paymentReceipt: paymentReceipt
        }
        setLoading(true)
        await request({
            path: `/applicant-statements`,
            body: {
                ...body,
                files: files
            },
        }).unwrap().catch((error)=>{
            showNotification({
                title: 'Ошибка',
                message: error?.data?.message ?? 'Ошибка',
                color: 'red',
                icon: <FileUpload size={24}/>,
            })
        })?.finally(() => {
            setLoading(false)
        })
    })
    const nextStep = () => {
        if (active === 0) {
            if (!form.values.inn) {
                form.setFieldError('inn', 'Введите ПИН')
            }
            if (!form.values.passportSeries) {
                form.setFieldError('passportSeries', 'Введите серию паспорта');
            }
            if (!form.values.passportNumber) {
                form.setFieldError('passportNumber', 'Введите номер паспорта');
            }
            if (!form.values.languageLevelCertificate) {
                form.setFieldError('languageLevelCertificate', 'Загрузите документ');
            }
            if (!form.values.actualResidence) {
                form.setFieldError('actualResidence', 'Введите адрес места фактического проживания');
            }
            if (!form.values.placeOfBirth) {
                form.setFieldError('placeOfBirth', 'Введите адрес места рождения');
            }
            if (!form.values.phone) {
                form.setFieldError('phone', 'Введите номер телефона');
            }
            if (!form.values.email) {
                form.setFieldError('email', 'Введите почту');
            }
            if (!form.values.diploma) {
                form.setFieldError('diploma', 'Загрузите документ');
            }
            if (!form.values.legalSpecialityDocument) {
                form.setFieldError('legalSpecialityDocument', 'Загрузите документ');
            }
            if (laborContract && !form.values.laborContract) {
                form.setFieldError('laborContract', 'Загрузите документ');
            }
            if (reference && !form.values.reference) {
                form.setFieldError('reference', 'Загрузите документ');
            }
            if (!form.values.paymentReceipt) {
                form.setFieldError('paymentReceipt', 'Загрузите документ');
            }
            form.values.laborActivities.forEach((item, index) => {
                if (!item.position) {
                    form.setFieldError(`laborActivities.${index}.position`, 'Введите должность');
                }
                if (!item.organization) {
                    form.setFieldError(`laborActivities.${index}.organization`, 'Введите наименование организации');
                }
                if (!item.location) {
                    form.setFieldError(`laborActivities.${index}.location`, 'Введите адрес организации');
                }
                if (!item.start) {
                    form.setFieldError(`laborActivities.${index}.start`, 'Введите дату начала');
                }
                if (!item.untilNow && !item.end) {
                    form.setFieldError(`laborActivities.${index}.end`, 'Введите дату окончания');
                }
            })
            if (
                !form.values.inn ||
                !form.values.passportSeries ||
                !form.values.passportNumber ||
                !form.values.languageLevelCertificate ||
                !form.values.actualResidence ||
                !form.values.placeOfBirth ||
                !form.values.phone ||
                !form.values.email ||
                !form.values.diploma ||
                !form.values.legalSpecialityDocument ||
                (laborContract && !form.values.laborContract) ||
                (reference && !form.values.reference) ||
                !form.values.paymentReceipt ||
                !form.values.laborActivities.every((item) => item.position && item.organization && item.location && item.start && (item.untilNow || item.end))
            ) return
        }
        setActive((current) => (current < 3 ? current + 1 : current))
    };
    const prevStep = () => {
        setActive((current) => (current > 0 ? current - 1 : current))
    };

    const pinCodeSearch = async () => {
        if (!form.values.inn) {
            form.setFieldError('inn', 'Введите ПИН')
            return
        }
        const {data} = await search({
            path: `oep/${form.values.inn}`,
            method: "GET",
        }) as {
            data: {
                isActive: boolean,
                authType: string,
            },
        }
        if (!!data?.isActive) {
            showNotification({
                title: 'Успешно',
                message: `ПИН найден отправлен на ${data.authType ?? 'почту'}`,
                color: 'green',
                icon: <IconChecks size={24}/>,
            })
        } else {
            showNotification({
                title: 'Ошибка',
                message: `Учётная запись на физическое лицо ${form.values.inn} не зарегистрирована в системе`,
                color: 'red',
                icon: <IconCircleX size={24}/>,
            })
        }
    }

    const PersonalDataAgreement = async () => {
        setLoading(true)
        const {data} = await getFile({
            path: `public/personal-data-agreement?pin=${form.values.inn}`,
            method: "GET",
        }) as {
            data: string
        }
        setDataAgreement(data)
        setOpenAgreement(true)
        setLoading(false)
    }

    useEffect(() => {
        if (isSuccess) {
            form.reset();
            exit && exit();
            showNotification({
                title: 'Успешно',
                message: 'Заявка успешно отправлена',
                color: 'green',
                icon: <Checks size={24}/>,
            })
        }
        if (isError) {
            const err = error as { status: number, data: any }
            if (err) {
                if (err.status && (err.status / 100 === 4)) {
                    const {data} = err as { data: { values: { [key: string]: string } } }
                    const {values} = data
                    for (const [key, value] of Object.entries(values)) {
                        form.setFieldError(key, value)
                        showNotification({
                            title: 'Ошибка',
                            message: `${key} - ${value}`,
                            color: 'red',
                            icon: <FileUpload size={24}/>,
                        })
                    }
                } else if (err.status && (err.status / 100 === 5)) {
                    showNotification({
                        title: 'Ошибка',
                        message: err.data?.message ?? 'Ошибка сервера',
                        color: 'red',
                        icon: <FileUpload size={24}/>,
                    })
                }
            }
        }
    }, [isSuccess, isError]);

    const personalDataError = form.errors.hasOwnProperty("passportSeries") || form.errors.hasOwnProperty("passportNumber") || form.errors.hasOwnProperty("languageLevelCertificate") || form.errors.hasOwnProperty("actualResidence") || form.errors.hasOwnProperty("placeOfBirth") || form.errors.hasOwnProperty("phone") || form.errors.hasOwnProperty("email")
    const expirienceError = form.errors.hasOwnProperty("diploma") || form.errors.hasOwnProperty("legalSpecialityDocument") || form.errors.hasOwnProperty("laborContract") || form.errors.hasOwnProperty("reference")

    const renderField = (name: string, value: string | null) => {
        return <Text size={"md"} weight={"bold"}>
            {
                name
            }:&nbsp;
            <Text span weight={"normal"}>
                {
                    value ?? 'Не заполнено'
                }
            </Text>
        </Text>
    }

    return <fieldset
        disabled={isLoading}
        style={{
            border: 'none',
        }}>
        <form onSubmit={onSubmit}>
            <Stepper active={active} breakpoint="sm">
                <Stepper.Step label="Информация">
                    <Accordion defaultValue={"personal-data"} variant="separated">
                        <Accordion.Item value="personal-data">
                            <Accordion.Control>Персональные данные <Text span color={"red"} weight={"bold"}>
                                {personalDataError ?
                                    'Ошибка' : null
                                }
                            </Text></Accordion.Control>
                            <Accordion.Panel>
                                <Grid>
                                    <Grid.Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                        <TextInput
                                            {...form.getInputProps('inn')}
                                            name="inn"
                                            label="ПИН"
                                            placeholder="Введите ПИН"
                                            required={true}
                                            maxLength={14}
                                            disabled={loading}
                                        />
                                    </Grid.Col>
                                    <Grid.Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                        <TextInput
                                            {...form.getInputProps('passportSeries')}
                                            label={"Серия паспорта"}
                                            placeholder={"Напишите серию паспорта"}
                                            required
                                            onChange={(e) => {
                                                form.setFieldValue('passportSeries', e.currentTarget.value ? e.currentTarget.value?.toUpperCase() : null)
                                            }}
                                        />
                                    </Grid.Col>
                                    <Grid.Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                        <TextInput
                                            {...form.getInputProps('passportNumber')}
                                            label={"Номер паспорта"}
                                            placeholder={"Напишите номер паспорта"}
                                            required
                                        />
                                    </Grid.Col>
                                    <Grid.Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                        <Select
                                            data={[
                                                {
                                                    label: "Кыргызская Республика",
                                                    value: ''
                                                }]}
                                            label={"Гражданство"}
                                            placeholder={"Выбрать гражданство"}
                                            required
                                            defaultValue={''}
                                        />
                                    </Grid.Col>
                                    <Grid.Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                        <Select
                                            data={[{
                                                label: 'Высшее юридическое',
                                                value: ''
                                            }]}
                                            label={"Образование"}
                                            placeholder={"Выбрать образование"}
                                            required
                                            defaultValue={''}
                                        />
                                    </Grid.Col>
                                    <Grid.Col xs={12} sm={12} md={4} lg={4} xl={4}>
                                        <Box pt={'0.45rem'}>
                                            <Group position="apart">
                                                <Text size={14}>
                                                    Знание гос языка
                                                </Text>
                                                {form.values.languageLevelCertificate ?
                                                    <Checks
                                                        size={24}
                                                        strokeWidth={2}
                                                        color={'green'}
                                                    />
                                                    : <FileAlert
                                                        size={24}
                                                        strokeWidth={2}
                                                        color={'red'}
                                                    />
                                                }
                                            </Group>
                                            <UseFileInput file={form.values.languageLevelCertificate}
                                                          setFile={(file) => form.setFieldValue("languageLevelCertificate", file)}
                                                          error={form.errors.languageLevelCertificate as string}
                                                          acceptFileType={"application/pdf"}
                                            />
                                        </Box>
                                        {/*<Select*/}
                                        {/*  {...form.getInputProps('languageLevel')}*/}
                                        {/*  data={LanguageLevel.map((item) => ({*/}
                                        {/*    label: item,*/}
                                        {/*    value: item*/}
                                        {/*  }))}*/}
                                        {/*  label={"Знание гос языка"}*/}
                                        {/*  placeholder={"Выбрать уровень владения"}*/}
                                        {/*  required*/}
                                        {/*/>*/}
                                    </Grid.Col>
                                    <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                        <TextInput
                                            {...form.getInputProps(`actualResidence`)}
                                            label={"Адрес места фактического проживания"}
                                            placeholder={"Напишите адрес"}
                                            required
                                        />
                                    </Grid.Col>
                                    <Grid.Col xs={12} sm={12} md={6} lg={6} xl={6}>
                                        <TextInput
                                            {...form.getInputProps('placeOfBirth')}
                                            label={"Адрес места рождения (по свидетельству о рождении)"}
                                            placeholder={"Напишите адрес"}
                                            required
                                        />
                                    </Grid.Col>
                                    <Grid.Col xs={6}>
                                        <TextInput
                                            {...form.getInputProps('phone')}
                                            label="Номер телефона"
                                            placeholder="Введите номер телефона"
                                            required={true}
                                        />
                                    </Grid.Col>
                                    <Grid.Col xs={6}>
                                        <TextInput
                                            {...form.getInputProps('email')}
                                            label="Email"
                                            placeholder="Введите почту"
                                            name="email"
                                            required={true}
                                        />
                                    </Grid.Col>
                                </Grid>
                            </Accordion.Panel>
                        </Accordion.Item>
                        <Accordion.Item value="expirience">
                            <Accordion.Control>Трудовая деятельность <Text span color={"red"} weight={"bold"}>
                                {expirienceError ?
                                    'Ошибка' : null
                                }
                            </Text></Accordion.Control>
                            <Accordion.Panel>
                                {form.values.laborActivities?.map((item, index) => {
                                    return <Paper shadow={"md"} p={"md"} withBorder my={"xs"}>
                                        <Grid>
                                            <Grid.Col span={3}>
                                                <DatePicker
                                                    locale="ru"
                                                    {...form.getInputProps(`laborActivities.${index}.start`)}
                                                    value={item.start ? new Date(item.start) : null}
                                                    onChange={(value) => form.getInputProps(`laborActivities.${index}.start`).onChange(dateFormatTo(value, 'datetime-local'))}
                                                    inputFormat={'DD.MM.YYYY'}
                                                    label="Дата начала"
                                                    placeholder="Выбрать дату"
                                                    required
                                                    allowLevelChange={false}
                                                    initialLevel={"year"}
                                                />
                                            </Grid.Col>
                                            <Grid.Col span={3}>
                                                <DatePicker
                                                    locale="ru"
                                                    {...form.getInputProps(`laborActivities.${index}.end`)}
                                                    onChange={(value) => form.getInputProps(`laborActivities.${index}.end`).onChange(dateFormatTo(value, 'datetime-local'))}
                                                    value={item.end ? new Date(item.end) : null}
                                                    inputFormat={'DD.MM.YYYY'}
                                                    label="Дата окончания"
                                                    placeholder="Выбрать дату"
                                                    required={!item.untilNow}
                                                    disabled={item.untilNow}
                                                    allowLevelChange={false}
                                                    initialLevel={"year"}
                                                />
                                            </Grid.Col>
                                            <Grid.Col span={2}>
                                                <Checkbox
                                                    label={"По настоящее время"}
                                                    checked={item.untilNow}
                                                    style={{
                                                        marginTop: 40
                                                    }}
                                                    onChange={(e) => {
                                                        form.setFieldValue(`laborActivities.${index}.untilNow`, e.currentTarget.checked)
                                                        if (e.currentTarget.checked) {
                                                            form.setFieldValue(`laborActivities.${index}.end`, null)
                                                        }
                                                    }
                                                    }
                                                />
                                            </Grid.Col>
                                            <Grid.Col span={4}>
                                                <TextInput
                                                    {...form.getInputProps(`laborActivities.${index}.position`)}
                                                    label={"Должность"}
                                                    placeholder={"Введите должность"}
                                                    required
                                                />
                                            </Grid.Col>
                                            <Grid.Col span={12}>
                                                <TextInput
                                                    {...form.getInputProps(`laborActivities.${index}.location`)}
                                                    label={"Расположение организации"}
                                                    placeholder={"Введите адрес"}
                                                    required
                                                />
                                            </Grid.Col>
                                            <Grid.Col span={12}>
                                                <TextInput
                                                    {...form.getInputProps(`laborActivities.${index}.organization`)}
                                                    label={"Наименование организации"}
                                                    placeholder={"Введите наименование организации"}
                                                    required
                                                />
                                            </Grid.Col>
                                            <Grid.Col span={12}>
                                                <Group position={"center"}>
                                                    {
                                                        form.values.laborActivities?.length !== 1 &&
                                                      <Button onClick={() => {
                                                          form.removeListItem('laborActivities', index)
                                                      }}
                                                              color={"red"}
                                                      >
                                                        <IconFileMinus/>
                                                        &nbsp;
                                                        Удалить
                                                      </Button>
                                                    }
                                                    {
                                                        index === form.values.laborActivities?.length - 1 &&
                                                      <Button onClick={() => {
                                                          form.setFieldValue('laborActivities', [
                                                              ...form.values?.laborActivities,
                                                              {
                                                                  start: '',
                                                                  untilNow: false,
                                                                  end: '',
                                                                  position: '',
                                                                  organization: '',
                                                                  location: '',
                                                              }
                                                          ])
                                                      }}
                                                              color={"blue"}
                                                      >
                                                        <IconFilePlus/>
                                                        &nbsp;
                                                        Добавить
                                                      </Button>
                                                    }
                                                </Group>
                                            </Grid.Col>
                                        </Grid>
                                    </Paper>
                                })}
                                <Grid mt={"xl"}>
                                    <Grid.Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid>
                                            {/*<Grid.Col span={12}>*/}
                                            {/*  <Group position="apart">*/}
                                            {/*    <Text size={mobileSize ? 14 : 17}>Заявление <Text span color={"red"}>*</Text></Text>*/}
                                            {/*    {form.values.application ?*/}
                                            {/*      <Checks*/}
                                            {/*        size={24}*/}
                                            {/*        strokeWidth={2}*/}
                                            {/*        color={'green'}*/}
                                            {/*      />*/}
                                            {/*      : <FileAlert*/}
                                            {/*        size={24}*/}
                                            {/*        strokeWidth={2}*/}
                                            {/*        color={'red'}*/}
                                            {/*      />*/}
                                            {/*    }*/}
                                            {/*  </Group>*/}
                                            {/*  <UseFileInput setFile={(file) => form.setFieldValue("application", file)}/>*/}
                                            {/*</Grid.Col>*/}
                                            <Grid.Col span={12}>
                                                <Group position="apart">
                                                    <Text size={mobileSize ? 14 : 17}>
                                                        Сведения об образовании (Указать все имеющиеся нотариально
                                                        удостоверенные копии дипломов о высшем образовании) <Text span
                                                                                                                  color={"red"}>*</Text>
                                                    </Text>
                                                    {form.values.diploma ?
                                                        <Checks
                                                            size={24}
                                                            strokeWidth={2}
                                                            color={'green'}
                                                        />
                                                        : <FileAlert size={24}
                                                                     strokeWidth={2}
                                                                     color={'red'}/>
                                                    }
                                                </Group>
                                                <UseFileInput file={form.values.diploma}
                                                              setFile={(file) => form.setFieldValue("diploma", file)}
                                                              error={form.errors.diploma as string}/>
                                            </Grid.Col>
                                            <Grid.Col span={12}>
                                                <Group position="apart">
                                                    <Text size={mobileSize ? 14 : 17}>
                                                        Трудовая книжка (Нотариально удостоверенная или удостоверенная
                                                        по последнему месту работы копия документа, подтверждающего стаж
                                                        работы по юридической специальности)<Text span
                                                                                                  color={"red"}>*</Text>
                                                    </Text>
                                                    {form.values.legalSpecialityDocument ?
                                                        <Checks
                                                            size={24}
                                                            strokeWidth={2}
                                                            color={'green'}
                                                        />
                                                        : <FileAlert
                                                            size={24}
                                                            strokeWidth={2}
                                                            color={'red'}
                                                        />
                                                    }
                                                </Group>
                                                <UseFileInput file={form.values.legalSpecialityDocument}
                                                              setFile={(file) => form.setFieldValue("legalSpecialityDocument", file)}
                                                              error={form.errors.legalSpecialityDocument as string}/>
                                            </Grid.Col>
                                            <Grid.Col span={12}>
                                                <Grid>
                                                    <Grid.Col span={12}>
                                                        <Checkbox
                                                            label={"Помощник адвоката"}
                                                            checked={laborContract}
                                                            onChange={(e) => {
                                                                setLaborContract(e.currentTarget.checked)
                                                                if (!e.currentTarget.checked) form.setFieldValue(`laborContract`, null)
                                                            }}
                                                        />
                                                    </Grid.Col>
                                                    {
                                                        laborContract &&
                                                      <Grid.Col span={12}>
                                                        <Group position="apart">
                                                          <Text size={mobileSize ? 14 : 17}>
                                                            Трудовой договор помощника адвоката
                                                          </Text>
                                                            {form.values.laborContract ?
                                                                <Checks
                                                                    size={24}
                                                                    strokeWidth={2}
                                                                    color={'green'}
                                                                />
                                                                : <FileAlert
                                                                    size={24}
                                                                    strokeWidth={2}
                                                                    color={'red'}
                                                                />
                                                            }
                                                        </Group>
                                                        <UseFileInput file={form.values.laborContract}
                                                                      setFile={(file) => form.setFieldValue("laborContract", file)}
                                                                      disabled={!laborContract}
                                                                      error={form.errors.laborContract as string}
                                                        />
                                                      </Grid.Col>
                                                    }
                                                </Grid>
                                            </Grid.Col>
                                            <Grid.Col span={12}>
                                                <Grid>
                                                    <Grid.Col span={12}>
                                                        <Checkbox
                                                            label={"Работали ли Вы в правоохранительных органах"}
                                                            checked={reference}
                                                            onChange={(e) => {
                                                                setReference(e.currentTarget.checked)
                                                                if (!e.currentTarget.checked) form.setFieldValue(`reference`, null)
                                                            }}
                                                        />
                                                    </Grid.Col>
                                                    {
                                                        reference &&
                                                      <Grid.Col span={12}>
                                                        <Group position="apart">
                                                          <Text size={mobileSize ? 14 : 17}>
                                                            Справка-объективка
                                                          </Text>
                                                            {form.values.reference ?
                                                                <Checks
                                                                    size={24}
                                                                    strokeWidth={2}
                                                                    color={'green'}
                                                                />
                                                                : <FileAlert
                                                                    size={24}
                                                                    strokeWidth={2}
                                                                    color={'red'}
                                                                />
                                                            }
                                                        </Group>
                                                        <UseFileInput file={form.values.reference}
                                                                      setFile={(file) => form.setFieldValue("reference", file)}
                                                                      error={form.errors.reference as string}
                                                        />
                                                      </Grid.Col>
                                                    }
                                                </Grid>
                                            </Grid.Col>
                                        </Grid>
                                    </Grid.Col>
                                </Grid>
                            </Accordion.Panel>
                        </Accordion.Item>
                    </Accordion>
                        <Grid mt={"xl"}>
                              <Grid.Col span={12}>
                                <Group position="apart">
                                  <Text size={mobileSize ? 14 : 17}>
                                    Квитанция об оплате
                                  </Text>
                                    {form.values.paymentReceipt ?
                                        <Checks
                                            size={24}
                                            strokeWidth={2}
                                            color={'green'}
                                        />
                                        : <FileAlert
                                            size={24}
                                            strokeWidth={2}
                                            color={'red'}
                                        />
                                    }
                                </Group>
                                <UseFileInput file={form.values.paymentReceipt}
                                              setFile={(file) => form.setFieldValue("paymentReceipt", file)}
                                              error={form.errors.paymentReceipt as string}
                                              required
                                />
                              </Grid.Col>
                        </Grid>
                </Stepper.Step>
                <Stepper.Step label="Подтверждение">
                    <Grid>
                        <Grid.Col span={12}>
                            <Paper shadow={"xs"} p={"sm"} withBorder>
                                {
                                    renderField('Серия паспорта', form.values?.passportSeries)
                                }
                                {
                                    renderField('Номер паспорта', form.values?.passportNumber)
                                }
                                {
                                    renderField('Гражданство', 'Кыргызская Республика')
                                }
                                {
                                    renderField('Образование', 'Высшее юридическое')
                                }
                                {
                                    renderField('Знание гос языка', form.values?.languageLevelCertificate ? 'Загружено' : null)
                                }
                                {
                                    renderField('Адрес места фактического проживания', form.values?.actualResidence)
                                }
                                {
                                    renderField('Адрес места рождения', form.values?.placeOfBirth)
                                }
                                {
                                    renderField('Номер телефона', form.values?.phone)
                                }
                                {
                                    renderField('Email', form.values?.email)
                                }
                                {
                                    renderField('Сведения об образовании (Указать все имеющиеся нотариально удостоверенные копии дипломов о высшем образовании)', form.values?.diploma ? 'Загружено' : null)
                                }
                                {
                                    renderField('Трудовая книжка (Нотариально удостоверенная или удостоверенная по последнему месту работы копия документа, подтверждающего стаж работы по юридической специальности)', form.values?.legalSpecialityDocument ? 'Загружено' : null)
                                }
                                {
                                    laborContract && renderField('Трудовой договор помощника адвоката', form.values?.laborContract ? 'Загружено' : null)
                                }
                                {
                                    reference && renderField('Справка-объективка', form.values?.reference ? 'Загружено' : null)
                                }
                                {
                                    form.values?.laborActivities?.map((item, index) => {
                                        return <Paper shadow={"md"} p={"sm"} withBorder my={"lg"}>
                                            <Grid>
                                                <Grid.Col span={3}>
                                                    {
                                                        renderField('Дата начала', item.start?.split('T')[0])
                                                    }
                                                </Grid.Col>
                                                <Grid.Col span={3}>
                                                    {
                                                        renderField('Дата окончания', item?.untilNow ? 'По настоящее время' : item.end?.split('T')[0])
                                                    }
                                                </Grid.Col>
                                                <Grid.Col span={6}>
                                                    {
                                                        renderField('Должность', item.position)
                                                    }
                                                </Grid.Col>
                                                <Grid.Col span={6}>
                                                    {
                                                        renderField('Место работы', item.location)
                                                    }
                                                </Grid.Col>
                                                <Grid.Col span={6}>
                                                    {
                                                        renderField('Организация', item.organization)
                                                    }
                                                </Grid.Col>
                                            </Grid>
                                        </Paper>
                                    })
                                }
                                {/*{*/}
                                {/*  renderField(*/}
                                {/*    'Сведения об образовании (Указать все имеющиеся нотариально удостоверенные копии дипломов о высшем образовании)',*/}
                                {/*    form.values.diploma ? 'Загружено' : null*/}
                                {/*  )*/}
                                {/*}*/}
                                {/*{*/}
                                {/*  renderField(*/}
                                {/*    'Трудовая книжка (Нотариально удостоверенная или удостоверенная по последнему месту работы копия документа, подтверждающего стаж работы по юридической специальности)',*/}
                                {/*    form.values.legalSpecialityDocument ? 'Загружено' : null*/}
                                {/*  )*/}
                                {/*}*/}
                                {
                                    laborContract && renderField(
                                        'Трудовой договор помощника адвоката',
                                        form.values.laborContract ? 'Загружено' : null
                                    )
                                }
                                {
                                    reference && renderField(
                                        'Справка-объективка',
                                        form.values.reference ? 'Загружено' : null
                                    )
                                }
                            </Paper>
                        </Grid.Col>
                        <Grid.Col span={12}>
                            <Paper shadow={"xl"} p={"sm"} withBorder style={{
                                backgroundColor: !checked ? "rgba(255,94,94,0.43)" : "rgba(64,192,87,0.43)"
                            }}>
                                <Center>
                                    {
                                        loading ? <Loader/> :
                                            <Checkbox
                                                size={"md"}
                                                sx={{
                                                    label: {
                                                        // textDecoration: 'underline red',
                                                        fontSize: 18,
                                                        wordBreak: 'break-word',
                                                    }
                                                }}
                                                label={<>Согласно
                                                    &nbsp;
                                                    <Anchor
                                                        href={"https://cbd.minjust.gov.kg/202269/edition/1239270/ru"}
                                                        target={"_blank"}>
                                                        Закону Кыргызской Республики «Об информации персонального
                                                        характера»
                                                    </Anchor>, даю согласие на обработку моих персональных данных.</>}
                                                checked={checked}
                                                onChange={(e) => {
                                                    setChecked(e.currentTarget.checked)
                                                    if (e?.currentTarget?.checked) {
                                                        PersonalDataAgreement()
                                                    }
                                                }}
                                            />
                                    }
                                </Center>
                            </Paper>
                        </Grid.Col>
                    </Grid>
                </Stepper.Step>
                <Stepper.Step label="Отправить">
                    <Grid>
                        <Grid.Col xs={6}>
                            <TextInput
                                {...form.getInputProps('inn')}
                                name="inn"
                                label="ПИН"
                                maxLength={14}
                                disabled={true}
                            />
                        </Grid.Col>
                        <Grid.Col xs={6} mb={"xs"}>
                            <TextInput
                                {...form.getInputProps('pinCode')}
                                name="pinCode"
                                label="ПИН-код (придет на указанную электронную почту при регистрации ЭЦП)"
                                required={true}
                                disabled={form.values.inn?.length !== 14 || loading}
                                rightSection={
                                    <Popover width={200} position="bottom" withArrow shadow="md" opened={opened}>
                                        <Popover.Target>
                                            <ActionIcon onClick={pinCodeSearch}
                                                        disabled={form.values.inn?.length !== 14}>
                                                <IconSearch onMouseEnter={open} onMouseLeave={close}/>
                                            </ActionIcon>
                                        </Popover.Target>
                                        <Popover.Dropdown sx={{pointerEvents: 'none'}}>
                                            <Text size="sm">
                                                {!form.values.inn ?
                                                    "Необходимо заполнить поле ПИН"
                                                    :
                                                    "Нажмите для получения пин-кода"}</Text>
                                        </Popover.Dropdown>
                                    </Popover>
                                }
                            />
                        </Grid.Col>
                        <Grid.Col xs={12} mt={"xl"}>
                            <Group position="center">
                                {
                                    loading ? <Loader/> :
                                        <Button type="submit" variant='filled' color={checked ? "green" : 'gray'}
                                                disabled={!checked || !form.values?.inn
                                                    || !form.values?.pinCode}>
                                            Отправить
                                            заявку</Button>
                                }
                            </Group>
                        </Grid.Col>
                    </Grid>
                </Stepper.Step>
            </Stepper>
            <Group position="center" mt="xl">
                {active !== 0 && <Button variant="default" onClick={prevStep} disabled={loading}>Назад</Button>}
                {active !== 2 && <Button onClick={nextStep}
                                         disabled={active === 1 ? (!checked || !dataAgreement) : false}>Вперед</Button>}
            </Group>
        </form>
        <Modal
            opened={openAgreement}
            centered
            overlayOpacity={0.55}
            overlayBlur={3}
            onClose={() => setOpenAgreement(false)}
            title={"Соглашение о персональных данных"}
            size={"70vw"}
            transition={"fade"}
            transitionDuration={500}
            transitionTimingFunction={"ease"}
            overflow={"outside"}
        >
            {
                !dataAgreement ? <Loader/> :
                    <iframe src={dataAgreement} width="100%" height="100%" frameBorder="0" style={{
                        height: '80vh'
                    }}/>
            }
        </Modal>
    </fieldset>
}
